import { useState } from "react";
import { Card, Form, Button, Alert, Container } from "react-bootstrap";
import {
  getAuth,
  createUserWithEmailAndPassword,
  updatePassword,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  setDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const SignupReferent = () => {
  const [email, setEmail] = useState("");
  const [tempPassword, setTempPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showTempPassword, setShowTempPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    setLoading(true);

    if (newPassword !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas");
      setLoading(false);
      return;
    }

    try {
      const auth = getAuth();
      const db = getFirestore();

      // Créer l'utilisateur dans Auth
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        tempPassword
      );

      // Mettre à jour avec le nouveau mot de passe
      await updatePassword(userCredential.user, newPassword);

      // Rechercher l'utilisateur dans la collection users
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("email", "==", email));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0];
        const userData = userDoc.data();

        // Supprimer le mot de passe des données utilisateur
        const { password, ...userDataWithoutPassword } = userData;

        // Créer un nouveau document avec l'ID Auth
        await setDoc(
          doc(db, "users", userCredential.user.uid),
          userDataWithoutPassword
        );
        // Supprimer l'ancien document
        await deleteDoc(userDoc.ref);

        // Rechercher et mettre à jour les documents dans companies
        const companiesRef = collection(db, "companies");
        const companiesQuery = query(companiesRef, where("referentId", "==", userDoc.id));
        const companiesSnapshot = await getDocs(companiesQuery);

        companiesSnapshot.forEach(async (companyDoc) => {
          await setDoc(
            companyDoc.ref,
            { referentId: userCredential.user.uid, isActive: true },
            { merge: true }
          );
        });

        setSuccess(true);
        // Réinitialiser les champs après succès
        setEmail("");
        setTempPassword("");
        setNewPassword("");
        setConfirmPassword("");
        // Redirection vers la page de connexion après 2 secondes
        setTimeout(() => {
          history.push("/login");
        }, 2000);
      } else {
        setError(
          "Aucun utilisateur trouvé avec cet email dans la base de données"
        );
      }
    } catch (error) {
      setError(
        error.code === "auth/email-already-in-use"
          ? "Cet email est déjà utilisé"
          : error.code === "auth/weak-password"
            ? "Le mot de passe doit contenir au moins 6 caractères"
            : error.message
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Card>
        <Card.Header>
          <Card.Title as="h4">Inscription Référent</Card.Title>
        </Card.Header>
        <Card.Body>
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError("")}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert
              variant="success"
              dismissible
              onClose={() => setSuccess(false)}>
              Inscription réussie ! Vous pouvez maintenant vous connecter avec
              votre email et votre nouveau mot de passe.
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Mot de passe temporaire</Form.Label>
              <div style={{ position: "relative" }}>
                <Form.Control
                  type={showTempPassword ? "text" : "password"}
                  value={tempPassword}
                  onChange={(e) => setTempPassword(e.target.value)}
                  required
                  style={{ paddingRight: "48px", borderRadius: "6px", height: "44px" }}
                />
                <button
                  type="button"
                  onClick={() => setShowTempPassword(!showTempPassword)}
                  aria-label={showTempPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}>
                  {showTempPassword ? (
                    <i className="fa fa-eye-slash" aria-hidden="true"></i>
                  ) : (
                    <i className="fa fa-eye" aria-hidden="true"></i>
                  )}
                </button>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Nouveau mot de passe</Form.Label>
              <div style={{ position: "relative" }}>
                <Form.Control
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  style={{ paddingRight: "48px", borderRadius: "6px", height: "44px" }}
                />
                <button
                  type="button"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  aria-label={showNewPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}>
                  {showNewPassword ? (
                    <i className="fa fa-eye-slash" aria-hidden="true"></i>
                  ) : (
                    <i className="fa fa-eye" aria-hidden="true"></i>
                  )}
                </button>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Confirmer le nouveau mot de passe</Form.Label>
              <div style={{ position: "relative" }}>
                <Form.Control
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  style={{ paddingRight: "48px", borderRadius: "6px", height: "44px" }}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  aria-label={showConfirmPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    width: "32px",
                    height: "32px",
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}>
                  {showConfirmPassword ? (
                    <i className="fa fa-eye-slash" aria-hidden="true"></i>
                  ) : (
                    <i className="fa fa-eye" aria-hidden="true"></i>
                  )}
                </button>
              </div>
            </Form.Group>

            <Button variant="primary" type="submit" disabled={loading} className="text-white">
              {loading ? "Inscription en cours..." : "S'inscrire"}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default SignupReferent;
